


































































import { vxm } from '../store.vuex';
import { Component, Vue } from 'vue-property-decorator';
import { Company } from '../models/company/companyprofile';
import { ATSJobListParams } from '../models/jobs/atsjoblistparams';
import { CandidatePortalClientCommonInfo } from '../models/utility/lookup';
import { Filter } from '../models/jobs/filter';
import router from '../router';
import VideoPlayer from '@/components/Commons/VideoPlayer.vue';
import Category from '@/components/Commons/Category.vue';

@Component({
  name: 'CompanyProfile',
  components: {
    VideoPlayer,
    Category,
  },
})
export default class CompanyProfile extends Vue {
  private jobListParams: ATSJobListParams = new ATSJobListParams();
  private totalJobs: number = 0;
  private radius: number = 0;

  get isLocationEnabled() {
    const latitude = vxm.jobs.latitude;
    const longitude = vxm.jobs.longitude;
    if (!longitude && !longitude) {
      return false;
    } else {
      return true;
    }
  }

  mounted() {
    const ccode = this.$route.params.Code || vxm.jobs.BrandingInfo.companycode;
    const candidatePortalClientCommonInfo = new CandidatePortalClientCommonInfo();
    candidatePortalClientCommonInfo.radius = vxm.jobs.FilterRadius;
    candidatePortalClientCommonInfo.latitude = vxm.jobs.latitude;
    candidatePortalClientCommonInfo.longitude = vxm.jobs.longitude;
    candidatePortalClientCommonInfo.companyCode = ccode;
    this.radius = vxm.jobs.FilterRadius;
    let jobPager = vxm.jobs.JobPager;
    this.totalJobs = jobPager.resultCount;
    console.log('companyProfileRequest-- ', [candidatePortalClientCommonInfo]);
    vxm.jobs.getCompanyInfo(candidatePortalClientCommonInfo);
    vxm.skills.getCategoryExpertiseData({
      parentCategoryId: null,
      searchAllCategories: false,
    });
  }

  parseUrl(videoURL: string): string {
    const nArr = videoURL.split('=');
    return nArr[1];
  }

  searchJobs() {
    this.jobListParams = vxm.jobs.JobListParams;
    this.jobListParams.resultPage = 1;
    this.jobListParams.resultSize = 10;
    this.jobListParams.sortCriteria.sortField = '05';
    this.jobListParams.geoLocation.requestPref = 'LATLONG';
    this.jobListParams.keywords = '';
    this.jobListParams.filter = new Filter();
    this.jobListParams.filter.radius = this.companyInfoData[0].radius;
    let filterConfig = vxm.jobs.searchFilterObj;
    filterConfig.jobTitle = '';
    filterConfig.jobType = '';
    filterConfig.jobSkills = [];
    filterConfig.industry = '';
    filterConfig.sort = '';
    vxm.jobs.setSearchFilterObj(filterConfig);
    vxm.jobs.setJobListParams(this.jobListParams);
    vxm.jobs.reloadJobs(this.jobListParams).then(() => {
      router.push({ name: 'Findjobs' });
    });
  }

  get companyInfoData(): Company[] {
    const cInfo: Company[] = [];
    cInfo.push(vxm.jobs.CompanyInfo);
    return cInfo;
  }
  getCompanyLogoUrl(companyCode: string): string {
    return vxm.jobs.getCompanyLogoUrl(companyCode);
  }
  goBackRoute() {
    this.$router.go(-1);
  }
  getFristCapitalletter(value: string): string {
    if (!value) return '';
    value = value.toString();
    return value
      .trim()
      .charAt(0)
      .toUpperCase();
  }
  getCompanyDistanceUnits(): string {
    return vxm.jobs.getCompanyDistanceUnit;
  }
  get categories() {
    return vxm.skills.expertiseDataWrapper.categories;
  }
  onSelectCategory(category) {
    if (category.linkedChildCategoriesCount) {
      this.$router.push({
        name: 'CategoryDetails',
        params: { id: category.categoryId, name: category.name },
      });
    } else {
      let filterConfig = vxm.jobs.searchFilterObj;
      filterConfig.categories = [category.categoryId];
      vxm.jobs.setSearchFilterObj(filterConfig);
      this.$router.push({ name: 'Findjobs' });
    }
  }
}
